<template>
  <div class="requirements dbox">
   
     
          <TextField2
          
            id="user_name"
            :placeholder="$t('user_name')"
            :label="$t('user_name')"
            :value="selectedArtist.user_name"
            :disabled="false"
           
            @blur="onTextFieldValueChange"
          />
          <!-- <TextField
            :id="'user_name'"
            v-bind="textFieldConfig"
            :value="selectedArtist.user_name"
            :placeholder="$t('user_name')"
            @valuechanged="onTextFieldValueChange"
            /> -->
          <TextField2
          
            id="password"
            :placeholder="$t('password')"
            :label="$t('password')"
            :value="selectedArtist.password"
            :disabled="false"
           
            @blur="onTextFieldValueChange"
          />
    
          <!-- <TextField
            :id="'password'"
            v-bind="textFieldConfig"
            :value="selectedArtist.password"
            :placeholder="$t('password')"
            @valuechanged="onTextFieldValueChange"
            /> -->
    
      
  </div>
</template>

<script>
import TextField from "@plugins/text-field/text-field";
import { EventHooks } from '../../../../../plugins/text-field';


export default {
  components: {
    TextField,
  },
  props: {
    selectedArtist: {
      type: Object,
      required: true
    },
  },
  data: function() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,

        validationEvent: EventHooks.OnBlur,
        valueChangedEvent: EventHooks.OnBlur,
      },
      // Mark: Data
    };
  },
  mounted: function() {
    
  },
  watch: {

  },
  computed: {
  },
  methods: {
    onTextFieldValueChange: function({name, value}) {
      console.log("::::::::::::::::",name,value)
      this.$emit('changed', {name, value});
    },
    // Mark: Methods
  },
}

</script>

<style lang="scss" scoped>

</style>
